import ErrorPage from './errorPage.view';

export default ErrorPage;
